export default __webpack_public_path__ + "static/media/gate.827a6650.svg";